module.exports = __webpack_public_path__ + "static/media/login-background.5c428b1d.png";